import { render } from "./PlayerDetail.vue?vue&type=template&id=15174988&scoped=true"
import script from "./PlayerDetail.vue?vue&type=script&lang=js"
export * from "./PlayerDetail.vue?vue&type=script&lang=js"

import "./PlayerDetail.vue?vue&type=style&index=0&id=15174988&scoped=true&lang=css"

import exportComponent from "/var/www/share/bb5.highdigital.de/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15174988"]])

export default __exports__